import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { ConfirmationDialogComponent } from '@app/shared/dialogs/confirmation-dialog/confirmation-dialog.component';
// import { Observable } from 'rxjs/Observable';

export declare interface DirtyComponent {
  canDeactivate: () => boolean | Observable<boolean>;
  dirtyDialogMetaData: { title: string, message: string, okText: string, cancelText: string };
}

@Injectable()
export class DeactivateGuard  {
  constructor(public dialog: MatDialog) {

  }
  canDeactivate(
    component: DirtyComponent,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.canDeactivate()) {
      if (nextState.url.indexOf('/login') > -1) {
        return true;
      } else {
        return this.openDialog(component);
      }
    } else {
      return true;
    }
  }

  openDialog(component: DirtyComponent): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: component.dirtyDialogMetaData.title,
        message: component.dirtyDialogMetaData.message,
        buttonText: {
          ok: component.dirtyDialogMetaData.okText,
          cancel: component.dirtyDialogMetaData.cancelText,
        }
      }
    });

    return dialogRef.afterClosed().pipe(map(result => {
      return result;
    }));
  }
}

